// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
}

.wrapper {
  padding: 20px;
}

.intro {
  text-align: center;
  margin-bottom: 24px;
}
.intro .logo {
  width: 110px;
  margin-bottom: 8px;
}
.intro h2 {
  font-family: AppFontBold, sans-serif;
  font-size: 24px;
  color: var(--ion-color-secondary);
  margin: 0 0 8px;
}
.intro .description {
  font-size: 14px;
  color: var(--ion-color-secondary);
  margin: 0;
}

ion-item {
  --border-width: 1px !important;
  border: none !important;
  --border-radius: 5px !important;
  margin-bottom: 0;
}

ion-input,
ion-textarea {
  --border: none !important;
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-secondary);
}

.stacked {
  position: static;
  z-index: 2;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-select::part(icon) {
  position: absolute;
  right: 0;
}

.hint,
.counter {
  font-family: AppFontLight, sans-serif;
  font-size: 12px;
  color: var(--ion-color-secondary);
  margin: 4px 0 8px;
}

.counter {
  text-align: right;
}

app-turnstile {
  margin: 12px 0;
}

.submit-btn {
  margin-top: 12px;
}

.card {
  border: 1px solid #e6e7e3;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
}

.success {
  text-align: center;
  background: rgba(var(--ion-color-primary-rgb), 0.08);
}
.success .success-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  margin-bottom: 12px;
}
.success .success-icon ion-icon {
  font-size: 40px;
  color: white;
}
.success h2 {
  font-family: AppFontBold, sans-serif;
  font-size: 22px;
  color: var(--ion-color-secondary);
  margin: 0 0 8px;
}
.success p {
  font-size: 14px;
  color: var(--ion-color-secondary);
  margin: 0 0 4px;
}

.summary h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-secondary);
  margin: 0 0 12px;
}
.summary dl {
  margin: 0;
}
.summary .summary-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.summary .summary-row + .summary-row {
  border-top: 1px solid #e6e7e3;
}
.summary dt {
  font-family: AppFontLight, sans-serif;
  flex-shrink: 0;
}
.summary dd {
  margin: 0;
  text-align: right;
  word-break: break-word;
}
.summary dd.comment {
  white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/withdrawal/withdrawal.page.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;AACD;;AACA;EACC,aAAA;AAED;;AAAA;EACC,kBAAA;EACA,mBAAA;AAGD;AAFC;EACC,YAAA;EACA,kBAAA;AAIF;AAFC;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,eAAA;AAIF;AAFC;EACC,eAAA;EACA,iCAAA;EACA,SAAA;AAIF;;AADA;EACC,8BAAA;EACA,uBAAA;EACA,+BAAA;EACA,gBAAA;AAID;;AAFA;;EAEC,yBAAA;EACA,iCAAA;EACA,gCAAA;AAKD;;AAHA;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AAMD;;AAJA;EACC,gBAAA;EACA,UAAA;AAOD;;AALA;EACC,eAAA;EACA,mBAAA;AAQD;;AANA;EACC,kBAAA;EACA,QAAA;AASD;;AAPA;;EAEC,qCAAA;EACA,eAAA;EACA,iCAAA;EACA,iBAAA;AAUD;;AARA;EACC,iBAAA;AAWD;;AATA;EACC,cAAA;AAYD;;AAVA;EACC,gBAAA;AAaD;;AAXA;EACC,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAcD;;AAZA;EACC,kBAAA;EACA,oDAAA;AAeD;AAdC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;AAgBF;AAfE;EACC,eAAA;EACA,YAAA;AAiBH;AAdC;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,eAAA;AAgBF;AAdC;EACC,eAAA;EACA,iCAAA;EACA,eAAA;AAgBF;;AAZC;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;AAeF;AAbC;EACC,SAAA;AAeF;AAbC;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AAeF;AAdE;EACC,6BAAA;AAgBH;AAbC;EACC,qCAAA;EACA,cAAA;AAeF;AAbC;EACC,SAAA;EACA,iBAAA;EACA,sBAAA;AAeF;AAdE;EACC,qBAAA;AAgBH","sourcesContent":["ion-header {\n\tbox-shadow: none;\n}\n.wrapper {\n\tpadding: 20px;\n}\n.intro {\n\ttext-align: center;\n\tmargin-bottom: 24px;\n\t.logo {\n\t\twidth: 110px;\n\t\tmargin-bottom: 8px;\n\t}\n\th2 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 24px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tmargin: 0 0 8px;\n\t}\n\t.description {\n\t\tfont-size: 14px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tmargin: 0;\n\t}\n}\nion-item {\n\t--border-width: 1px !important;\n\tborder: none !important;\n\t--border-radius: 5px !important;\n\tmargin-bottom: 0;\n}\nion-input,\nion-textarea {\n\t--border: none !important;\n\tcolor: var(--ion-color-secondary);\n\tfont-family: AppFont, sans-serif;\n}\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--ion-color-secondary);\n}\n.stacked {\n\tposition: static;\n\tz-index: 2;\n}\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\nion-select::part(icon) {\n\tposition: absolute;\n\tright: 0;\n}\n.hint,\n.counter {\n\tfont-family: AppFontLight, sans-serif;\n\tfont-size: 12px;\n\tcolor: var(--ion-color-secondary);\n\tmargin: 4px 0 8px;\n}\n.counter {\n\ttext-align: right;\n}\napp-turnstile {\n\tmargin: 12px 0;\n}\n.submit-btn {\n\tmargin-top: 12px;\n}\n.card {\n\tborder: 1px solid #e6e7e3;\n\tborder-radius: 12px;\n\tpadding: 20px;\n\tmargin-bottom: 16px;\n}\n.success {\n\ttext-align: center;\n\tbackground: rgba(var(--ion-color-primary-rgb), 0.08);\n\t.success-icon {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 64px;\n\t\theight: 64px;\n\t\tborder-radius: 50%;\n\t\tbackground: var(--ion-color-primary);\n\t\tmargin-bottom: 12px;\n\t\tion-icon {\n\t\t\tfont-size: 40px;\n\t\t\tcolor: white;\n\t\t}\n\t}\n\th2 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 22px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tmargin: 0 0 8px;\n\t}\n\tp {\n\t\tfont-size: 14px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tmargin: 0 0 4px;\n\t}\n}\n.summary {\n\th3 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 16px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tmargin: 0 0 12px;\n\t}\n\tdl {\n\t\tmargin: 0;\n\t}\n\t.summary-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tgap: 16px;\n\t\tpadding: 8px 0;\n\t\tfont-size: 14px;\n\t\tcolor: var(--ion-color-secondary);\n\t\t& + .summary-row {\n\t\t\tborder-top: 1px solid #e6e7e3;\n\t\t}\n\t}\n\tdt {\n\t\tfont-family: AppFontLight, sans-serif;\n\t\tflex-shrink: 0;\n\t}\n\tdd {\n\t\tmargin: 0;\n\t\ttext-align: right;\n\t\tword-break: break-word;\n\t\t&.comment {\n\t\t\twhite-space: pre-line;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
